<template>
  <div>
    <h4
      class="font-weight-regular text-center"
      style="font-size: 22px;"
    >
      Substitutions
    </h4>

    <section class="order-sub__sub-button-wrapper col-lg-9">
      <v-btn
        class="order-sub__sub-button"
        :color="activeColor($options.MISSING.CALL_ME)"
        @click.stop="updateReplacementStatus($options.MISSING.CALL_ME.id)"
        rounded>

        <div class="checkout-label-font-size text-capitalize e2e-button-callme">
          call me
        </div>
      </v-btn>

      <v-btn
        class="order-sub__sub-button"
        :color="activeColor($options.MISSING.REPLACE)"
        @click.stop="updateReplacementStatus($options.MISSING.REPLACE.id)"
        rounded>

        <div class="checkout-label-font-size text-capitalize e2e-button-replace">
          replace
        </div>

      </v-btn>

      <v-btn class="order-sub__sub-button"
             :color="activeColor($options.MISSING.DONT_REPLACE)"
             @click.stop="updateReplacementStatus($options.MISSING.DONT_REPLACE.id)"
             rounded>

        <div class="checkout-label-font-size text-capitalize e2e-button-dontreplace">
          don't replace
        </div>
      </v-btn>
    </section>

    <section class="order-sub__missing-text text-center">{{ missingText }}</section>

  </div>
</template>

<script>

import { mapState } from "vuex";

const MISSING = Object.freeze({
  CALL_ME: {
    id: 1,
    text: "We will call you before we replace an out-of-stock product",
  },
  REPLACE: {
    id: 2,
    text: "We will replace an out-of-stock product without contacting you",
  },
  DONT_REPLACE: { id: 3, text: "We will not replace an out-of-stock product" },
});

export default {
  name: "OrderSubstitutions",
  computed: {
    ...mapState({
      order: (state) => state.orders.order,
      missingId: state => state.orders.order.missingId,
    }),
    missingText() {
      return Object.values(this.$options.MISSING).find(
        (m) => m.id === this.order.missingId,
      ).text;
    },
  },
  MISSING,
  methods: {
    activeColor(missing) {
      return missing.id === this.order.missingId ? "primary" : "";
    },
    updateReplacementStatus(replacementValue) {
      this.$store.commit("orders/UPDATE", { name: "missingId", val: replacementValue });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-sub {
  &__sub-button {
    width: 110px;
    height: 50px;

    &-wrapper {
      display: flex;
      justify-content: space-between;
      margin: 24px auto;
    }
  }

  &__missing-text {
    font-size: 12px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .order-sub {
    &__sub-button {
      width: 120px;

      &-wrapper {
        margin: auto;
        padding: 0;
      }
    }

    &__missing-text {
      font-size: 16px;
    }
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .order-sub {
    &__sub-button {
      width: 180px;
    }
  }
}
</style>
